/*** IMPORTS FROM imports-loader ***/


module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};




//////////////////
// WEBPACK FOOTER
// ../~/es-abstract/helpers/mod.js
// module id = 156
// module chunks = 3